module.exports = __webpack_public_path__ + "img/fish.a7acaa78.png";